import {usePageDataUrl} from '@github-ui/pull-request-page-data-tooling/use-page-data-url'
import {queryOptions, useSuspenseQuery} from '@github-ui/react-query'
import {reactFetchJSON} from '@github-ui/verified-fetch'
import type {ActivityPayload} from '../../../routes/route-payload-types'
import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'

export function useSuspenseActivityPageData({
  sinceTimestamp,
  lastActivityTimestamp,
}: {
  sinceTimestamp: string
  lastActivityTimestamp: string | null
}) {
  return useSuspenseQuery(useActivityQueryOptions({sinceTimestamp, lastActivityTimestamp}))
}

function useActivityQueryOptions({
  sinceTimestamp,
  lastActivityTimestamp,
}: {
  sinceTimestamp: string
  lastActivityTimestamp: string | null
}) {
  const queryKey = [PageData.activity, sinceTimestamp, lastActivityTimestamp] as const

  const searchParams = new URLSearchParams()
  searchParams.append('since', sinceTimestamp)
  const apiURL = usePageDataUrl(PageData.activity, searchParams.toString())

  return queryOptions({
    queryKey,
    queryFn: () => fetchActivityPageData(apiURL),
    staleTime: Infinity,
  })
}

async function fetchActivityPageData(url: string): Promise<ActivityPayload> {
  const response = await reactFetchJSON(url)
  if (!response.ok) throw new Error(`HTTP ${response.status}`)
  return response.json()
}
